import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  "data-testid": "step-taxResidence",
  class: "container"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = {
  key: 0,
  class: "row--next-tax-residence"
}
const _hoisted_5 = { class: "row--next-tax-residence__describe-close-form" }
const _hoisted_6 = { class: "tax-residence-text" }
const _hoisted_7 = {
  key: 1,
  class: "row--next-tax-residence"
}
const _hoisted_8 = { class: "row--next-tax-residence__describe-close-form" }
const _hoisted_9 = { class: "tax-residence-text" }
const _hoisted_10 = {
  key: 2,
  class: "row--add-new-tax-residence"
}
const _hoisted_11 = { class: "add-tax-residence__text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "add-tax-residence__char" }, null, -1)
const _hoisted_13 = { class: "add-tax-residence__text" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "add-tax-residence__char" }, null, -1)
const _hoisted_15 = { class: "field--poland-tax-residence-field__disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxResidenceField = _resolveComponent("TaxResidenceField")!
  const _component_Error = _resolveComponent("Error")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.taxResidenceHeader`)), 1),
    _createElementVNode("form", {
      class: "form-for-tax-residence",
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"]),
      onKeydown: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handlePendingTabNavigation && _ctx.handlePendingTabNavigation(...args)), ["tab"]))
    }, [
      _createVNode(_component_TaxResidenceField, {
        name: _ctx.TaxField.FIRST_TAX_RESIDENCE,
        "pass-default-tax-country": 
                    null !== _ctx.taxResidenceData
                        ? _ctx.taxResidenceData.firstTaxCountry
                        : ''
                ,
        "country-disable": 
                    _ctx.taxResidenceData?.firstTaxCountry ? true : false
                ,
        "pass-default-tin-number": _ctx.firstTinNumberFromServer,
        "cy-data": "tax-residence-first",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.receiveData(_ctx.TaxField.FIRST_TAX_RESIDENCE, $event))),
        onValidateTin: _ctx.handleValidateTin
      }, null, 8, ["name", "pass-default-tax-country", "country-disable", "pass-default-tin-number", "onValidateTin"]),
      _createElementVNode("div", null, [
        (_ctx.isOpenSecondTaxResidence)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.anotherTaxResidence`)), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "tax-residence-close-form",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (
                                _ctx.handleTaxResidence(
                                    _ctx.TaxField.SECOND_TAX_RESIDENCE
                                )
                            ))
                })
              ]),
              _createVNode(_component_TaxResidenceField, {
                name: _ctx.TaxField.SECOND_TAX_RESIDENCE,
                "cy-data": "tax-residence-two",
                "pass-default-tax-country": 
                            _ctx.taxResidenceData?.secondTaxCountry || ''
                        ,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (
                            _ctx.receiveData(_ctx.TaxField.SECOND_TAX_RESIDENCE, $event)
                        )),
                onValidateTin: _ctx.handleValidateTin
              }, null, 8, ["name", "pass-default-tax-country", "onValidateTin"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isOpenThirdTaxResidence)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.anotherTaxResidence`)), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "tax-residence-close-form",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (
                                _ctx.handleTaxResidence(_ctx.TaxField.THIRD_TAX_RESIDENCE)
                            ))
                })
              ]),
              _createVNode(_component_TaxResidenceField, {
                name: _ctx.TaxField.THIRD_TAX_RESIDENCE,
                "cy-data": "tax-residence-three",
                "pass-default-tax-country": 
                            _ctx.taxResidenceData?.thirdTaxCountry || ''
                        ,
                onInput: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.receiveData(_ctx.TaxField.THIRD_TAX_RESIDENCE, $event)
                        )),
                onValidateTin: _ctx.handleValidateTin
              }, null, 8, ["name", "pass-default-tax-country", "onValidateTin"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isOpenThirdTaxResidence)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (!_ctx.isOpenSecondTaxResidence)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "add-tax-residence",
                    "cy-data": "add-tax-residence",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (
                            _ctx.handleTaxResidence(_ctx.TaxField.SECOND_TAX_RESIDENCE)
                        ))
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.addNewTaxResidence`)), 1),
                    _hoisted_12
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "add-tax-residence",
                    "cy-data": "add-tax-residence",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.handleTaxResidence(_ctx.TaxField.THIRD_TAX_RESIDENCE)
                        ))
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.addNewTaxResidence`)), 1),
                    _hoisted_14
                  ])),
              _createVNode(_component_Error, {
                name: "addSecondTaxCountry",
                class: "error-tax-residence-position"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.disclaimer`)), 1),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.TAX_OFFICE_DETAILS,
        "data-testid": "btn-taxResidence-nextStep",
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        data: _ctx.formData,
        class: "button button--submit",
        disabled: !_ctx.formIsValid,
        onClick: _ctx.handleNextStep
      }, null, 8, ["action", "button-value", "data", "disabled", "onClick"])
    ], 40, _hoisted_3)
  ]))
}